<template>
  <v-app>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>محتوای ایستا</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <router-link to="/article-management/add-article">
                <v-btn class="mb-2 red accent-3 white--text button">
                  آیتم جدید
                </v-btn>              
              </router-link> -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >آیا میخواهید این آیتم را حذف کنید؟</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >لغو کردن</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
                  >تایید کردن</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <img
          :src="item.image"
          alt=""
          height="100"
          width="150"
          class="py-2 rounded"
        />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="9FA8DA" class="mr-2" @click="getUser(item)">
          mdi-pencil
        </v-icon>
        <v-icon color="9FA8DA" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> ریکوردی یافت نشد </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
import axios from "axios";
import { mapMutations, mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  data: () => ({
    page: 1,
    search: "",
    listData1: [],
    listData2: [],
    dialog: false,
    dialogDelete: false,
    deleteId: null,
    headers: [
      { text: "تصویر", value: "image", align: "right" },
      { text: "عنوان", value: "title", align: "right" },
      { text: "نوع", value: "type", align: "right" },
      { text: "تنظیمات", value: "actions", sortable: false, align: "left" },
    ],
    dialogm1: "",
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
    },
    defaultItem: {
      picture: "",
      title: "",
      category: "",
      place: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    ...mapGetters(["tokenValue"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    ...mapMutations(["setArticleInfo"]),
    async getUser(item) {
      await axios
        .get(`${baseURL}StaticContentDetail/GetById?id=${item.id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          this.setArticleInfo(response.data.data);
          this.$router.push(
            `/static-management/static-content-edit/${item.id}`
          );
        });
    },
    async getList() {
      await axios
        .get(`${baseURL}StaticContentDetail/GetAll`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          this.listData1 = response.data.data;
          this.listData1.map((item) => {
            this.desserts.push({
              title: item.title,
              id: item.id,
              image: item.image,
              type: item.type,
            });
          });
        });
    },
    async changePage(item) {
      this.desserts = [];
      await axios
        .get(
          `http://agriapi.spad-host.ir/api/ProductGroup/GetAll?pageNumber=${item}&pageSize=10`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          this.page = response.data.totalPages;
          this.listData1 = response.data.data;
          this.listData1.map((item) => {
            this.desserts.push({
              title: item.title,
              id: item.id,
            });
          });
          this.parentList.push({
            list: this.listData1[0].id,
            count: this.listData1.length,
          });
        });
    },

    deleteItem(item) {
      this.deleteId = item.id;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await axios.delete(
        `http://api.karaclub.com/api/User/Delete?id=${this.deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    commentHandler(item) {
      this.$router.push({ name: "article-comment", params: { id: item.id } });
    },
  },
};
</script>
<style>
.v-icon--link.mdi-pencil.theme--light.success--text {
  color: rgb(0, 184, 55);
  font-size: 20px !important;
}
.v-icon--link.mdi-delete.theme--light.warning--text {
  color: rgb(184, 0, 0);
  font-size: 20px !important;
}

/* .v-btn:not(.v-btn--round).v-size--default {
     
} */
</style>>

